import styled from "styled-components";
import { TableCorrectionsRow } from "./ExtendedThermalCalculation";
import { SyntheticEvent, useEffect, useMemo, useState } from "react";
import { useThermalState } from "./ThermalStateProvider";
import { useTranslation } from "react-i18next";
import { useExtendedThermalCalculation } from "./extendedCalculation.hook";
import { sanitizeNumericInput, toDisplay } from "../../../../services/helpers.service";

const TableBody = styled.div`
`;

export const CorrectionsTableBody = () => {
  const { t } = useTranslation() as any;
  const { performance, corrections, setCorrections } = useThermalState();
  const { formatCalc } = useExtendedThermalCalculation()

  const [fixationCountStr, setFixationCountStr] = useState(toDisplay(corrections.fixation.count));
  const [fixationDiameterStr, setFixationDiameterStr] = useState(toDisplay(corrections.fixation.diameter));
  const [fixationDtuleStr, setFixationDtuleStr] = useState(toDisplay(corrections.fixation.dtule));

  useEffect(() => {
    const parsed = parseFloat(fixationCountStr);
    const current = fixationCountStr === "" || isNaN(parsed) ? undefined : parsed;
    if (current !== corrections.fixation.count) {
      setFixationCountStr(toDisplay(corrections.fixation.count));
    }
  }, [corrections.fixation.count, fixationCountStr]);

  useEffect(() => {
    const parsed = parseFloat(fixationDiameterStr);
    const current = fixationDiameterStr === "" || isNaN(parsed) ? undefined : parsed;
    if (current !== corrections.fixation.diameter) {
      setFixationDiameterStr(toDisplay(corrections.fixation.diameter));
    }
  }, [corrections.fixation.diameter, fixationDiameterStr]);

  useEffect(() => {
    const parsed = parseFloat(fixationDtuleStr);
    const current = fixationDtuleStr === "" || isNaN(parsed) ? undefined : parsed;
    if (current !== corrections.fixation.dtule) {
      setFixationDtuleStr(toDisplay(corrections.fixation.dtule));
    }
  }, [corrections.fixation.dtule, fixationDtuleStr]);

  const fixationCorrectionOptions = useMemo(() => {
    return [
      { value: corrections.fixation.type, label: t(`material.${corrections.fixation.type}`) },
      { value: "GALVANIZED_STEEL_FIXATION", label: t("material.GALVANIZED_STEEL_FIXATION") },
      { value: "RVS_FIXATION", label: t("material.RVS_FIXATION") },
    ].filter((x, index, array) => index === array.findIndex((t) => t.value === x.value))
    // .sort((a, b) => a.label.localeCompare(b.label));
  }, [corrections.fixation, t]);

  const handleEditableOptionChange = (event: SyntheticEvent<HTMLSelectElement>) => {
    const input = event.target as HTMLInputElement
    const type = input.dataset.type!;

    if (input.value) {

      let values = {}
      switch (input.value) {
        case 'GALVANIZED_STEEL_FIXATION':
          values = { lambda: 50, diameter: corrections.fixation.diameter, count: corrections.fixation.count, dtule: corrections.fixation.dtule, }
          break;
        case 'RVS_FIXATION':
          values = { lambda: 17, diameter: corrections.fixation.diameter, count: corrections.fixation.count, dtule: corrections.fixation.dtule, }
          break;
        default:
          values = {}
          break;
      }

      setCorrections({
        ...corrections,
        [type]: { active: true, type: input.value, ...values },
      });
    }
  }

  const handleFixationActiveChange = (state: boolean) => {
    setCorrections({
      ...corrections,
      fixation: { ...corrections.fixation, active: state },
    })
  }

  const handleEditableFixationCountChange = (event: SyntheticEvent<HTMLInputElement>) => {
    const input = event.target as HTMLInputElement;
    const type = input.dataset.type!;
    const value = sanitizeNumericInput(input.value);
    setFixationCountStr(value);
    const parsed = parseFloat(value);
    const count = value === "" || isNaN(parsed) ? undefined : parsed;
    if (type) {
      setCorrections({
        ...corrections,
        [type]: { ...corrections[type], count },
      });
    }
  }

  const handleEditableFixationDtuleChange = (event: SyntheticEvent<HTMLInputElement>) => {
    const input = event.target as HTMLInputElement;
    const type = input.dataset.type!;
    const value = sanitizeNumericInput(input.value);
    setFixationDtuleStr(value);
    const parsed = parseFloat(value);
    const dtule = value === "" || isNaN(parsed) ? undefined : parsed;
    if (type) {
      setCorrections({
        ...corrections,
        [type]: { ...corrections[type], dtule },
      });
    }
  }

  const handleEditableFixationDiameterChange = (event: SyntheticEvent<HTMLInputElement>) => {
    const input = event.target as HTMLInputElement;
    const type = input.dataset.type!;
    const value = sanitizeNumericInput(input.value);
    setFixationDiameterStr(value);
    const parsed = parseFloat(value);
    const diameter = value === "" || isNaN(parsed) ? undefined : parsed;
    if (type) {
      setCorrections({
        ...corrections,
        [type]: { ...corrections[type], diameter },
      });
    }
  }

  return (
    <TableBody>
      {/* Fixation */}
      <TableCorrectionsRow
        active={corrections.fixation.active}
        classes="-corrections -even-row"
        type="fixation"
        title={t("extendedThermalCalculation.correction.fixation").toUpperCase()}
        text={t(`material.${corrections.fixation.type}`)}
        count={fixationCountStr}
        dtule={fixationDtuleStr}
        diameter={fixationDiameterStr}
        dfa={toDisplay(performance.fixationDfa)}
        lambdaValue={corrections.fixation.active ? formatCalc(corrections.fixation.lambda) : formatCalc(0)}
        insulationValue={formatCalc(undefined)}
        UValue={formatCalc(performance.fixationUValue)}

        editableFixationCount={true}
        onEditableFixationCountChange={handleEditableFixationCountChange}
        editableFixationDtule={true}
        onEditableFixationDtuleChange={handleEditableFixationDtuleChange}
        editableFixationDiameter={true}
        onEditableFixationDiameterChange={handleEditableFixationDiameterChange}
        editableFixationDfa={true}

        onActiveChange={handleFixationActiveChange}
        options={fixationCorrectionOptions}
        onOptionChange={handleEditableOptionChange}
      />
    </TableBody>)
}
